import React, { useRef, useEffect, useState } from 'react';
import "./popuptrancheinfo.css"

interface PopupTrancheInfoProps {
    popupInfo: {
        title: string;
        description: string;
    };
}

const PopupTrancheInfo: React.FC<PopupTrancheInfoProps> = ({
    popupInfo,
}) => {
    return (
        <div className="sc-9393b5c4-3 iTKQSM">
            <h4 className="sc-9393b5c4-4 beVeVF">{popupInfo.title}</h4>
            <p className="sc-9393b5c4-5 dALwZb">
            {popupInfo.description}
            </p>
        </div>

    );
};

export default PopupTrancheInfo;


